import { DirectDealsList } from '@openx/components-direct-deals/lib/DirectDealsList/DirectDealsList.tsx';
import { RequestDirectDealModalProvider } from '@openx/components-direct-deals/lib/utils/context/RequestDirectDealModalContext.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { useTranslation } from 'react-i18next';

export const DirectDealsListPage = () => {
  const { t } = useTranslation();

  return (
    <PageHeader titlePrefix="OpenXSelect" title={t('Direct Deals')}>
      <RequestDirectDealModalProvider>
        <DirectDealsList />
      </RequestDirectDealModalProvider>
    </PageHeader>
  );
};
